import { chakra, Flex } from "@chakra-ui/react";
import Agreement from "@/pages/agreement/ZhDoc";
import Privacypolicy from "@/pages/privacypolicy/ZhDoc";

const Wrap = chakra(Flex, {
  baseStyle: {
    color: "#010313",
    flexDirection: "column",
    gap: "10px",
  },
});
const ZhDoc = () => {
  return (
    <Wrap>
      <Agreement />
      <Privacypolicy />
    </Wrap>
  );
};

export default ZhDoc;
